import { cn } from '@/shadcn/lib/utils';
import { ImagePlay } from 'lucide-react';

interface Props {
    className?: string | string[];
}

export function ImagePlaceholder(props: Props) {
    return (
        <div
            className={cn(
                'flex-1 flex w-full min-h-full h-auto flex-col items-center justify-center gap-2 px-3 py-4 bg-[#f2f2f2]',
                props.className,
            )}
        >
            <div className="max-w-[250px] flex shrink-0 aspect-square w-[40%] items-center justify-center rounded-full bg-cust-primary/15 text-text-highlight">
                <ImagePlay className="text-cust-primary size-[40%]" />
            </div>

            {/*<div>
                <img src="/images/image_placeholder.png" alt="no image" />
            </div>
            */}
        </div>
    );
}
